import { render, staticRenderFns } from "./widgetInvite.vue?vue&type=template&id=0004077e&scoped=true"
import script from "./widgetInvite.vue?vue&type=script&lang=js"
export * from "./widgetInvite.vue?vue&type=script&lang=js"
import style0 from "./widgetInvite.vue?vue&type=style&index=0&id=0004077e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0004077e",
  null
  
)

export default component.exports